import axios from "axios";

// TV / video news — newest-first list from the dedicated video_articles table.
// GET /api/tv?limit=N → [{ videoId, title, channel, url, thumbnail,
//                          publishedAt, description }]

export const fetchTvVideos = async (limit = 40) => {
  // Generous timeout + one retry for Render cold starts.
  const attempt = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/api/tv`, {
      params: { limit },
      timeout: 45000,
    });

  for (let i = 0; i < 2; i++) {
    try {
      const res = await attempt();
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      if (i === 1) {
        console.warn("tv fetch failed:", err.message);
        return [];
      }
      await new Promise((r) => setTimeout(r, 1500));
    }
  }
  return [];
};
